import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {personModel, statsRecord} from "../../model/personModel"

import { Platform } from 'ionic-angular';

import { AngularFire, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2';
/*
  Generated class for the LeaderDashBoard page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-leader-dash-board',
  templateUrl: 'leader-dash-board.html'
})
export class LeaderDashBoardPage {
    groups: Array<any> = new Array<any>();
    constructor(
        private af: AngularFire,
        private platform: Platform,
        public navCtrl: NavController,
        public navParams: NavParams,
        public _statsRecord: statsRecord,
        public personModel:personModel   
    ) {
        var that = this;
        this.platform.ready().then(() => {
            that.af.auth.subscribe(auth => {
                personModel.me.members.forEach(function (value, index, arry) {
                    console.log(value);
                    that.groups.push(that._statsRecord.getGroupRecord(value));
                });
            })
        });
    }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LeaderDashBoardPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/leader-dash-board/leader-dash-board.ts